import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye } from "lucide-react";
import DeleteConfirmModal from "./DeleteConfirmModal";

const initialDrafts = Array.from({ length: 3 }).map((_, i) => ({
  id: i + 1,
  title: "Cappadocia: A Fairytale Destination Above the Clouds",
  desc: "Cappadocia, located in the heart of Turkey, is famous for its surreal landscapes, fairy chimneys, and colorful...",
  lastUpdate: "May 20, 2026",
  status: "Draft",
  image: "/img/blog/featured-post.svg",
}));

export default function DraftsList({ onCountChange }) {
  const navigate = useNavigate();
  const [drafts, setDrafts] = useState(initialDrafts);
  const [pendingDeleteId, setPendingDeleteId] = useState(null);

  const handleConfirmDelete = () => {
    const next = drafts.filter((draft) => draft.id !== pendingDeleteId);
    setDrafts(next);
    onCountChange?.(next.length);
    setPendingDeleteId(null);
  };

  return (
    <section>
      <div className="bg-white border border-slate-100 shadow-sm rounded-2xl overflow-hidden">
        {drafts.map((draft, i) => (
          <div
            key={draft.id}
            className={`flex items-center gap-5 p-4 sm:p-5 ${
              i !== drafts.length - 1 ? "border-b border-slate-100" : ""
            }`}
          >
            <div className="w-24 h-16 sm:w-28 sm:h-20 rounded-xl overflow-hidden bg-slate-200 shrink-0">
              <img
                src={draft.image}
                alt={draft.title}
                className="w-full h-full object-cover"
              />
            </div>

            <div className="flex-1 min-w-0">
              <h4 className="font-semibold text-slate-900 text-sm sm:text-base leading-snug mb-1 truncate">
                {draft.title}
              </h4>
              <p className="text-sm text-slate-500 leading-relaxed mb-2 line-clamp-2 max-w-2xl">
                {draft.desc}
              </p>
              <p className="text-xs text-slate-400">
                Last Update: {draft.lastUpdate}
              </p>
            </div>

            <div className="flex items-center gap-3 shrink-0">
              <span className="text-xs font-semibold text-slate-500 bg-slate-100 px-3 py-1.5 rounded-full">
                {draft.status}
              </span>
              <button
                type="button"
                aria-label="Preview draft"
                onClick={() => navigate("/dashboard/edit-draft", { state: { draft } })}
                className="w-9 h-9 rounded-lg border border-slate-200 flex items-center justify-center text-blue-500 hover:bg-blue-50 transition-colors"
              >
                <Eye className="w-4 h-4" />
              </button>
              <button
                type="button"
                aria-label="Delete draft"
                onClick={() => setPendingDeleteId(draft.id)}
                className="w-9 h-9 flex items-center justify-center hover:opacity-80 transition-opacity shrink-0"
              >
                <img src="/img/blog/Delete.svg" alt="" className="w-9 h-9" />
              </button>
            </div>
          </div>
        ))}

        {drafts.length === 0 && (
          <p className="text-sm text-slate-400 text-center py-8">
            No drafts yet.
          </p>
        )}
      </div>

      <DeleteConfirmModal
        open={pendingDeleteId !== null}
        onCancel={() => setPendingDeleteId(null)}
        onConfirm={handleConfirmDelete}
      />
    </section>
  );
}
